import { createContext} from "react";

let token = localStorage.getItem("hms_access_token")
? localStorage.getItem("hms_access_token")
: "";
export const UserContext = createContext(token);

